const OPPORTUNITY_ROOT = "#\\/capture\\/(?:tracked|archived)-opportunities";
const PROPOSAL_ROOT = "#\\/proposals\\/(?:view|archived)";
const MISC_ANALYSIS_ROOT = "#\\/misc-analysis\\/(?:view|archived)";

const SUB_ENTITY_LINK_PATTERNS = [
  {
    entityType: "OPPORTUNITY",
    subEntityType: "DOCUMENT",
    pattern: new RegExp(`^${OPPORTUNITY_ROOT}\\/(\\d+)\\/research\\/view\\/(\\d+)`),
  },
  {
    entityType: "OPPORTUNITY",
    subEntityType: "SHREDDING_REPORT",
    pattern: new RegExp(`^${OPPORTUNITY_ROOT}\\/(\\d+)\\/shredding\\/(\\d+)`),
  },
  {
    entityType: "OPPORTUNITY",
    subEntityType: "AMENDMENT_REPORT",
    pattern: new RegExp(`^${OPPORTUNITY_ROOT}\\/(\\d+)\\/amendment-handling\\/(?:document|excel)\\/(\\d+)`),
  },
  {
    entityType: "PROPOSAL",
    subEntityType: "DOCUMENT",
    pattern: new RegExp(`^${PROPOSAL_ROOT}\\/(\\d+)\\/writing\\/view\\/(\\d+)`),
  },
  {
    entityType: "PROPOSAL",
    subEntityType: "SHREDDING_REPORT",
    pattern: new RegExp(`^${PROPOSAL_ROOT}\\/(\\d+)\\/shredding\\/(\\d+)`),
  },
  {
    entityType: "PROPOSAL",
    subEntityType: "AMENDMENT_REPORT",
    pattern: new RegExp(`^${PROPOSAL_ROOT}\\/(\\d+)\\/amendment-handling\\/(?:document|excel)\\/(\\d+)`),
  },
  {
    entityType: "PROPOSAL",
    subEntityType: "ACRONYM_REPORT",
    pattern: new RegExp(`^${PROPOSAL_ROOT}\\/(\\d+)\\/acronym-report\\/(\\d+)`),
  },
  {
    entityType: "MISC_ANALYSIS",
    subEntityType: "DOCUMENT",
    pattern: new RegExp(`^${MISC_ANALYSIS_ROOT}\\/(\\d+)\\/(?:writing|proposal-writing)\\/view\\/(\\d+)`),
  },
  {
    entityType: "MISC_ANALYSIS",
    subEntityType: "SHREDDING_REPORT",
    pattern: new RegExp(`^${MISC_ANALYSIS_ROOT}\\/(\\d+)\\/shredding\\/(\\d+)`),
  },
  {
    entityType: "MISC_ANALYSIS",
    subEntityType: "AMENDMENT_REPORT",
    pattern: new RegExp(`^${MISC_ANALYSIS_ROOT}\\/(\\d+)\\/amendment-handling\\/(?:document|excel)\\/(\\d+)`),
  },
  {
    entityType: "MISC_ANALYSIS",
    subEntityType: "ACRONYM_REPORT",
    pattern: new RegExp(`^${MISC_ANALYSIS_ROOT}\\/(\\d+)\\/acronym-report\\/(\\d+)`),
  },
];

const ENTITY_LINK_PATTERNS = [
  {
    entityType: "OPPORTUNITY",
    pattern: /^#\/capture\/(?:tracked|archived)-opportunities\/(\d+)/,
  },
  {
    entityType: "PROPOSAL",
    pattern: /^#\/proposals\/(?:view|archived)\/(\d+)/,
  },
  { entityType: "CONTRACT", pattern: /^#\/contracts\/(?:all|archived)\/(\d+)/ },
  {
    entityType: "MISC_ANALYSIS",
    pattern: /^#\/misc-analysis\/(?:view|archived)\/(\d+)/,
  },
];

export const resolveEntityLink = (hash) => {
  for (const { entityType, subEntityType, pattern } of SUB_ENTITY_LINK_PATTERNS) {
    const match = hash?.match(pattern);
    if (match) {
      return {
        entityType,
        entityId: match[1],
        subEntityType,
        subEntityId: match[2],
      };
    }
  }
  for (const { entityType, pattern } of ENTITY_LINK_PATTERNS) {
    const match = hash?.match(pattern);
    if (match) {
      return { entityType, entityId: match[1] };
    }
  }
  return null;
};
